export const rightIcon =(
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14.417 10L6.70898 2.29201L5.58398 3.41701L12.188 10L5.58398 16.583L6.70898 17.708L14.417 10Z" fill="white"/>
    </svg>
)


